import styled from '@emotion/styled';

import { ReactComponent as VolumeOffIcon } from '@icons/volume-mute.svg';
import { ReactComponent as VolumeOnIcon } from '@icons/volume-on.svg';
import { buttonBase } from '@styles/mixins/button';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

interface ButtonVolumeProps
  extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  isMuted?: boolean;
}

export const ButtonVolume: React.FC<ButtonVolumeProps> = ({ isMuted, className, onClick }) => {
  return (
    <Button className={className} aria-label={`volume is ${isMuted ? 'off' : 'on'}`} onClick={onClick}>
      {isMuted ? <VolumeOffIcon role="presentation" /> : <VolumeOnIcon role="presentation" />}
    </Button>
  );
};

const Button = styled.button`
  padding: 15px;
  width: 160px;
  height: 160px;
  ${buttonBase};

  ${getMediaqueryStyled('lg')} {
    width: 60px;
    height: 60px;
  }
`;

// const StyledVolumeOffButton = styled(VolumeOffIcon)``;
